import { render, staticRenderFns } from "./RiverList.vue?vue&type=template&id=6af5abfd&scoped=true"
import script from "./RiverList.vue?vue&type=script&lang=js"
export * from "./RiverList.vue?vue&type=script&lang=js"
import style0 from "./RiverList.vue?vue&type=style&index=0&id=6af5abfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5abfd",
  null
  
)

export default component.exports